export default "__VITE_ASSET__CIBtxtqU__"